import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
export function KidsMartialArtsWhatYouLearn() {
  return <section className="py-24 bg-off-white" data-id="element-2162">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2163">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-2164">
          <div data-id="element-2165">
            <h2 className="text-4xl md:text-5xl text-ink mb-8" data-id="element-2166">
              What You'll Learn
            </h2>
            <ul className="flex flex-col gap-4" data-id="element-2167">
              {['Respect and courtesy towards others', 'Goal setting and perseverance', 'Physical fitness and healthy habits', 'Self-defense and conflict avoidance', 'Teamwork and sportsmanship', 'Fundamental martial arts techniques'].map((item, idx) => <li key={idx} className="flex items-start gap-4 text-lg text-gray-warm" data-id="element-2168">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-2169" />
                  <span data-id="element-2170">{item}</span>
                </li>)}
            </ul>
            <div className="mt-10" data-id="element-2171">
              <Link to="/SignMeUp" className="btn-primary" data-id="element-2172">
                Start With a Trial Class
              </Link>
            </div>
          </div>
          <div className="relative rounded-2xl overflow-hidden shadow-xl h-[400px]" data-id="element-2173">
            <img src="https://images.unsplash.com/photo-1517438476312-10d79c077509?auto=format&fit=crop&w=2000&q=80" alt="Training at Storm Taekwondo" className="block w-full h-full object-cover" data-id="element-2174" />
          </div>
        </div>
      </div>
    </section>;
}